(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
    const inlineSearch = event.target.closest('predictive-search.pfs-header-search');
    if (!inlineSearch || typeof inlineSearch.close !== 'function') return;
    const input = inlineSearch.querySelector('input[type="search"]');
    if (input && document.activeElement !== input) input.focus();
    inlineSearch.close();
    event.preventDefault();
  });
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pfs-homepage"] && !Shopify.designMode) return;
  try {
    
(() => {
  const registryKey = '__pfsHomepageController';
  if (window[registryKey]) {
    window[registryKey].initialize(document);
    return;
  }

  const instances = new Map();
  const rootSelector = '[data-pfs-homepage]';

  function interpolate(pattern, values) {
    return Object.entries(values).reduce((text, [key, value]) => {
      return text.replace(new RegExp('\\{\\{\\s*' + key + '\\s*\\}\\}|\\{' + key + '\\}|\\[' + key + '\\]|%' + key + '%', 'g'), String(value));
    }, pattern);
  }

  function initializeRoot(root) {
    if (instances.has(root)) return;

    const abortController = new AbortController();
    const cleanups = [];
    const listen = (target, type, callback, options = {}) => {
      if (target) target.addEventListener(type, callback, { ...options, signal: abortController.signal });
    };
    let destroyed = false;
    let revealObserver;
    let carouselObserver;
    let timer;
    const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
    const ownerDocument = root.ownerDocument;
    const carousel = root.querySelector('.slideshow');
    const slides = carousel ? [...carousel.querySelectorAll('[data-slide]')] : [];
    const dots = carousel ? [...carousel.querySelectorAll('[data-go-slide]')] : [];
    const playback = carousel?.querySelector('#slide-toggle');
    const progress = carousel?.querySelector('.slide-progress > span');
    const number = carousel?.querySelector('#slide-number');
    const slideStatus = carousel?.querySelector('#slide-status');
    const playLabel = root.dataset.playLabel || 'Diashow abspielen';
    const pauseLabel = root.dataset.pauseLabel || playback?.getAttribute('aria-label') || 'Diashow pausieren';
    const interval = 7000;
    let current = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
    let paused = false;
    let inView = !('IntersectionObserver' in window);
    let remaining = interval;
    let startedAt = 0;
    let running = false;
    let touchStart;

    function hasFocusedSlide() {
      return slides.some(slide => slide.contains(ownerDocument.activeElement));
    }

    function shouldRun() {
      return !destroyed && slides.length > 1 && !paused && !hasFocusedSlide() && inView && !ownerDocument.hidden;
    }

    function syncPlayback() {
      if (!carousel || destroyed) return;
      const playing = shouldRun();
      if (running && !playing) {
        remaining = Math.max(0, remaining - (performance.now() - startedAt));
        window.clearTimeout(timer);
        timer = undefined;
        running = false;
      }
      if (playing && !running) {
        startedAt = performance.now();
        running = true;
        timer = window.setTimeout(() => {
          timer = undefined;
          running = false;
          remaining = 0;
          if (shouldRun()) go(current + 1, false);
          else syncPlayback();
        }, remaining);
      }
      carousel.classList.toggle('is-held', !playing);
      if (playback) {
        playback.classList.toggle('is-paused', paused);
        playback.setAttribute('aria-label', paused ? playLabel : pauseLabel);
      }
    }

    function resetProgress() {
      if (!progress) return;
      progress.classList.add('reset');
      void progress.offsetWidth;
      progress.classList.remove('reset');
    }

    function slideName(index) {
      const slide = slides[index];
      return slide?.dataset.slideLabel || dots[index]?.getAttribute('aria-label')?.split(':').slice(1).join(':').trim() || slide?.querySelector('h2')?.textContent.replace(/\s+/g, ' ').trim() || '';
    }

    function updateSlideState(manual) {
      slides.forEach((slide, index) => {
        const active = index === current;
        slide.classList.toggle('is-active', active);
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, index) => {
        const active = index === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });
      if (number) number.textContent = String(current + 1).padStart(2, '0');
      if (manual && slideStatus) {
        const pattern = root.dataset.slideStatusLabel;
        slideStatus.textContent = pattern
          ? interpolate(pattern, { current: current + 1, total: slides.length, title: slideName(current) })
          : [slides[current]?.getAttribute('aria-label'), slideName(current)].filter(Boolean).join(': ');
      }
    }

    function go(index, manual = true) {
      if (!slides.length || destroyed) return;
      if (manual && hasFocusedSlide()) carousel.focus({ preventScroll: true });
      window.clearTimeout(timer);
      timer = undefined;
      running = false;
      remaining = interval;
      current = ((index % slides.length) + slides.length) % slides.length;
      updateSlideState(manual);
      resetProgress();
      syncPlayback();
    }

    if (carousel && slides.length) {
      updateSlideState(false);
      listen(carousel.querySelector('#slide-prev'), 'click', () => go(current - 1));
      listen(carousel.querySelector('#slide-next'), 'click', () => go(current + 1));
      dots.forEach((dot, index) => listen(dot, 'click', () => {
        const destination = Number.parseInt(dot.dataset.goSlide, 10);
        go(Number.isFinite(destination) ? destination : index);
      }));
      listen(playback, 'click', () => {
        paused = !paused;
        syncPlayback();
      });
      listen(carousel, 'focusin', syncPlayback);
      listen(carousel, 'focusout', () => queueMicrotask(syncPlayback));
      listen(carousel, 'keydown', event => {
        if (event.ctrlKey || event.metaKey || event.altKey || event.target.closest('input,textarea,select,[contenteditable="true"]')) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          go(current + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      listen(ownerDocument, 'visibilitychange', syncPlayback);
      listen(carousel, 'touchstart', event => {
        const touch = event.changedTouches[0];
        touchStart = touch ? { x: touch.clientX, y: touch.clientY } : undefined;
      }, { passive: true });
      listen(carousel, 'touchend', event => {
        const touch = event.changedTouches[0];
        if (!touchStart || !touch) return;
        const dx = touch.clientX - touchStart.x;
        const dy = touch.clientY - touchStart.y;
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.3) go(current + (dx < 0 ? 1 : -1));
        touchStart = undefined;
      }, { passive: true });
      listen(carousel, 'touchcancel', () => { touchStart = undefined; }, { passive: true });
      if ('IntersectionObserver' in window) {
        carouselObserver = new IntersectionObserver(entries => {
          const entry = entries[0];
          if (!entry || destroyed) return;
          inView = entry.isIntersecting && entry.intersectionRatio >= 0.15;
          syncPlayback();
        }, { threshold: [0, 0.15] });
        carouselObserver.observe(carousel);
      }
      resetProgress();
    }

    const reveals = [...root.querySelectorAll('.section-heading,.categories > a,.trust-strip > div,.liege-photo,.liege-copy,.advice-section,.faq > div')];
    reveals.forEach((element, index) => {
      element.classList.add('reveal');
      if (element.parentElement.classList.contains('categories')) element.style.setProperty('--reveal-delay', `${(index % 5) * 55}ms`);
    });
    if ('IntersectionObserver' in window) {
      revealObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !destroyed) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08 });
    }

    function syncMotionPreference() {
      if (destroyed) return;
      root.classList.toggle('motion-ready', !motionPreference.matches);
      reveals.forEach(element => {
        if (motionPreference.matches || !revealObserver) element.classList.add('is-visible');
        else if (!element.classList.contains('is-visible')) revealObserver.observe(element);
      });
      syncPlayback();
    }

    if (motionPreference.addEventListener) listen(motionPreference, 'change', syncMotionPreference);
    else if (motionPreference.addListener) {
      motionPreference.addListener(syncMotionPreference);
      cleanups.push(() => motionPreference.removeListener(syncMotionPreference));
    }

    const filters = root.querySelector('.filters');
    const productCards = [...root.querySelectorAll('#products [data-product-category]')];
    const filterButtons = [...root.querySelectorAll('[data-filter]')];
    const productStatus = root.querySelector('#product-status');
    const hasDefaults = productCards.some(card => card.dataset.default === 'true');
    const selectionLabel = root.dataset.selectionLabel || filterButtons.find(button => button.dataset.filter === 'all')?.textContent.trim() || 'Unsere Auswahl';
    const countPattern = root.dataset.productCountLabel || '{count} Produkte angezeigt: {selection}';

    function filterProducts(button) {
      const category = button?.dataset.filter || 'all';
      let count = 0;
      productCards.forEach(card => {
        const visible = category === 'all' ? !hasDefaults || card.dataset.default === 'true' : card.dataset.productCategory === category;
        card.hidden = !visible;
        if (visible) count += 1;
      });
      filterButtons.forEach(candidate => {
        const active = candidate === button;
        candidate.classList.toggle('active', active);
        candidate.setAttribute('aria-pressed', String(active));
      });
      if (productStatus) {
        productStatus.textContent = interpolate(countPattern, {
          count,
          selection: category === 'all' ? selectionLabel : button.textContent.trim()
        });
      }
    }

    if (filters && productCards.length && filterButtons.length) {
      filterButtons.forEach(button => listen(button, 'click', () => filterProducts(button)));
      filters.hidden = false;
      filterProducts(filterButtons.find(button => button.classList.contains('active')) || filterButtons.find(button => button.dataset.filter === 'all') || filterButtons[0]);
    }

    instances.set(root, () => {
      destroyed = true;
      window.clearTimeout(timer);
      abortController.abort();
      carouselObserver?.disconnect();
      revealObserver?.disconnect();
      cleanups.forEach(cleanup => cleanup());
      root.classList.remove('motion-ready');
      instances.delete(root);
    });
    syncMotionPreference();
  }

  function initialize(context) {
    if (context.matches?.(rootSelector)) initializeRoot(context);
    context.querySelectorAll(rootSelector).forEach(initializeRoot);
  }

  function unload(context) {
    for (const [root, cleanup] of instances) {
      if (context === root || context.contains(root)) cleanup();
    }
  }

  window[registryKey] = { initialize, unload };
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => unload(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
})();


  } catch(e) { console.error(e); }
})();
})();
